// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================
   家政管理系统 - 现代化重新设计
   设计理念：清新、专业、易用
   ================================ */

/* CSS 变量 - 设计系统 */
:root {
  /* 主色调 - 暖橙色系（与小程序一致） */
  --primary-color: #ff6f20;
  --primary-hover: #e65a10;
  --primary-light: #fff7ed;

  /* 功能色 */
  --success-color: #10b981;
  --success-hover: #059669;
  --warning-color: #f59e0b;
  --danger-color: #ef4444;
  --danger-hover: #dc2626;
  --info-color: #ff6f20;
  --purple-color: #8b5cf6;
  --orange-color: #f97316;

  /* 中性色 */
  --text-primary: #1f2937;
  --text-secondary: #6b7280;
  --text-muted: #9ca3af;
  --border-color: #e5e7eb;
  --bg-primary: #ffffff;
  --bg-secondary: #f9fafb;
  --bg-tertiary: #f3f4f6;

  /* 阴影 */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

  /* 圆角 */
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 16px;
  --radius-xl: 24px;

  /* 间距 */
  --space-xs: 4px;
  --space-sm: 8px;
  --space-md: 12px;
  --space-lg: 16px;
  --space-xl: 24px;
  --space-2xl: 32px;

  /* 过渡 */
  --transition-fast: 150ms ease;
  --transition-base: 200ms ease;
  --transition-slow: 300ms ease;
}

/* 全局重置 */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 50%, #fef3c7 100%);
  min-height: 100vh;
}

/* ================================
   主容器 - 手机样式居中展示（屏幕1/3宽度）
   ================================ */
.container {
  max-width: 33.33vw;
  margin: 0 auto;
  padding: 0;
  min-height: 100vh;
  background: var(--bg-secondary);
  box-shadow: 0 0 40px rgba(0,0,0,0.08);
}

/* ================================
   页面头部
   ================================ */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-2xl);
  padding: var(--space-xl) var(--space-2xl);
  background: var(--bg-primary);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
}

.page-title-section {
  display: flex;
  align-items: center;
  gap: var(--space-lg);
}

.page-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, var(--primary-color), var(--info-color));
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  box-shadow: var(--shadow-md);
}

.page-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.5px;
}

.page-subtitle {
  margin: 4px 0 0 0;
  font-size: 14px;
  color: var(--text-secondary);
}

/* 主按钮样式 */
.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: var(--space-sm);
  padding: 12px 24px;
  background: linear-gradient(135deg, var(--primary-color), var(--info-color));
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-base);
  box-shadow: var(--shadow-md);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.btn-primary:active {
  transform: translateY(0);
}

.btn-primary svg {
  width: 20px;
  height: 20px;
}

/* ================================
   统计卡片区域
   ================================ */
.stats-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--space-lg);
  margin-bottom: var(--space-2xl);
}

.stat-card {
  background: var(--bg-primary);
  padding: var(--space-xl);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-color);
  transition: all var(--transition-base);
}

.stat-card:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: var(--space-md);
}

.stat-icon.blue { background: var(--primary-light); }
.stat-icon.green { background: #ecfdf5; }
.stat-icon.orange { background: #fff7ed; }
.stat-icon.purple { background: #f5f3ff; }

.stat-label {
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: var(--space-xs);
  font-weight: 500;
}

.stat-value {
  font-size: 32px;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -1px;
}

/* ================================
   搜索和筛选栏
   ================================ */
.search-section {
  display: flex;
  gap: var(--space-md);
  margin-bottom: var(--space-xl);
}

.search-input-wrapper {
  flex: 1 1;
  position: relative;
}

.search-input-wrapper svg {
  position: absolute;
  left: var(--space-lg);
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  color: var(--text-muted);
}

.search-input {
  width: 100%;
  padding: 14px var(--space-lg) 14px 48px;
  border: 2px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 15px;
  background: var(--bg-primary);
  transition: all var(--transition-fast);
}

.search-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px rgba(8, 145, 178, 0.1);
}

.filter-select {
  padding: 14px var(--space-xl);
  border: 2px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 15px;
  background: var(--bg-primary);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.filter-select:focus {
  outline: none;
  border-color: var(--primary-color);
}

/* ================================
   阿姨卡片网格
   ================================ */
.housekeepers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: var(--space-xl);
}

/* 阿姨卡片 */
.housekeeper-card {
  background: var(--bg-primary);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
  overflow: hidden;
  transition: all var(--transition-slow);
  position: relative;
}

.housekeeper-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--primary-color), var(--info-color));
  opacity: 0;
  transition: opacity var(--transition-base);
}

.housekeeper-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-xl);
}

.housekeeper-card:hover::before {
  opacity: 1;
}

/* 卡片状态样式 */
.card-unpublished {
  background: #e0f0ff !important;
}

.card-published {
  background: var(--bg-primary) !important;
}

.card-status-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
}

.status-tag {
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 8px;
  color: #fff;
}

.status-tag.draft { background: #9ca3af; }
.status-tag.pending { background: #f59e0b; }
.status-tag.published { background: #ff6f20; }

.share-btn-card {
  background: #ff6f20;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 4px 8px;
  font-size: 14px;
  cursor: pointer;
  margin-left: 8px;
}

/* 分享弹窗 */
.share-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.share-modal {
  background: #fff;
  border-radius: 20px;
  padding: 32px;
  width: 400px;
  text-align: center;
}

.share-modal-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 24px;
}

.share-options {
  display: flex;
  justify-content: space-around;
  margin-bottom: 24px;
}

.share-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.share-icon-box {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #fff;
}

.share-icon-box.wechat { background: #07c160; }
.share-icon-box.link { background: #ff6f20; }

.share-option-label {
  font-size: 14px;
  color: #4b5563;
}

/* 卡片头部 */
.card-header {
  display: flex;
  padding: var(--space-xl);
  gap: var(--space-lg);
  border-bottom: 1px solid var(--border-color);
  background: linear-gradient(180deg, var(--bg-secondary), transparent);
  align-items: flex-start;
}

.card-photo-wrapper {
  position: relative;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.card-photo {
  width: 100px;
  height: 100px;
  border-radius: var(--radius-lg);
  object-fit: cover;
  border: 3px solid var(--bg-primary);
  box-shadow: var(--shadow-md);
  background: var(--bg-tertiary);
}

.card-photo-placeholder {
  width: 100px;
  height: 100px;
  border-radius: var(--radius-lg);
  background: linear-gradient(135deg, var(--primary-light), var(--bg-tertiary));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  border: 3px solid var(--bg-primary);
  box-shadow: var(--shadow-md);
}

.card-photo-upload {
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 32px;
  height: 32px;
  background: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: var(--shadow-md);
  transition: all var(--transition-fast);
  border: 2px solid var(--bg-primary);
  z-index: 10;
}

.card-photo-upload:hover {
  background: var(--primary-hover);
  transform: scale(1.1);
}

.card-photo-upload svg {
  width: 18px;
  height: 18px;
  color: white;
}

/* 新的卡片信息区域样式 */
.card-info-new {
  flex: 1 1;
  min-width: 0;
  padding-top: 4px;
}

.card-name-row-new {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  margin-bottom: var(--space-md);
}

.card-name-new {
  font-size: 22px;
  font-weight: 800;
  color: #000000;
  margin: 0;
  letter-spacing: -0.3px;
}

.card-info-details-new {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.8;
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-sm);
}

.card-info-details-new .phone-line {
  width: 100%;
  margin-top: 2px;
}

/* 标签展示区域 - 头像正下方 */
.card-labels-section-outside {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-sm);
  padding: var(--space-md) var(--space-xl) 0;
  align-items: center;
}

.label-tag-green {
  display: inline-block;
  padding: 4px 10px;
  color: #ff6f20;
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-weight: 500;
  background: rgba(255, 111, 32, 0.1);
}

/* 照片展示区域 */
.photo-display-section {
  margin-bottom: var(--space-lg);
}

.photo-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-sm);
}

.photo-edit-btn {
  padding: 4px 8px;
  background: rgba(255, 111, 32, 0.1);
  color: var(--primary-color);
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  font-size: 12px;
  gap: 4px;
}

.photo-edit-btn:hover {
  background: rgba(255, 111, 32, 0.2);
}

.photo-edit-btn svg {
  width: 14px;
  height: 14px;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--space-md);
}

.photo-grid-item {
  aspect-ratio: 1;
  border-radius: var(--radius-md);
  overflow: hidden;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
}

.photo-grid-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-grid-empty {
  aspect-ratio: 1;
  border-radius: var(--radius-md);
  background: var(--bg-tertiary);
  border: 1px dashed var(--border-color);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  font-size: 12px;
}

/* 卡片内容 */
.card-body {
  padding: var(--space-xl);
}

.card-section {
  margin-bottom: var(--space-lg);
}

.card-section:last-child {
  margin-bottom: 0;
}

.card-section-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: var(--space-sm);
  display: flex;
  align-items: center;
  gap: var(--space-xs);
}

.card-section-label svg {
  width: 14px;
  height: 14px;
}

.card-address {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.6;
  padding: var(--space-md);
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
  display: flex;
  align-items: flex-start;
  gap: var(--space-sm);
}

.card-address svg {
  width: 16px;
  height: 16px;
  color: var(--text-muted);
  flex-shrink: 0;
  margin-top: 2px;
}

/* 工作经验样式 */
.card-experience {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

.experience-item {
  padding: var(--space-md);
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
  border-left: 3px solid var(--primary-color);
}

.experience-date {
  font-size: 13px;
  font-weight: 600;
  color: var(--primary-color);
  margin-bottom: var(--space-xs);
}

.experience-desc {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.6;
}

.card-text {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.6;
  padding: var(--space-md);
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
}

.card-summary {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.7;
  padding: var(--space-md);
  background: linear-gradient(135deg, #fffbeb, #fef3c7);
  border: 1px solid #fde68a;
  border-radius: var(--radius-md);
  max-height: 100px;
  overflow-y: auto;
  white-space: pre-wrap;
}

.card-summary-empty {
  font-style: italic;
  color: var(--text-muted);
}

/* 自我介绍编辑区域样式 */
.self-intro-edit-container {
  position: relative;
}

.self-intro-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-sm);
}

.self-intro-edit-btn {
  padding: 4px 8px;
  background: rgba(255, 111, 32, 0.1);
  color: var(--primary-color);
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  font-size: 12px;
  gap: 4px;
}

.self-intro-edit-btn:hover {
  background: rgba(255, 111, 32, 0.2);
}

.self-intro-edit-btn svg {
  width: 14px;
  height: 14px;
}

.self-intro-textarea {
  width: 100%;
  padding: var(--space-md);
  border: 2px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 14px;
  font-family: inherit;
  line-height: 1.6;
  resize: vertical;
  min-height: 80px;
  transition: all var(--transition-fast);
}

.self-intro-textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.1);
}

.self-intro-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-sm);
  margin-top: var(--space-sm);
}

.self-intro-save-btn,
.self-intro-cancel-btn {
  padding: 6px 12px;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.self-intro-save-btn {
  background: linear-gradient(135deg, var(--primary-color), var(--info-color));
  color: white;
}

.self-intro-save-btn:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.self-intro-cancel-btn {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.self-intro-cancel-btn:hover {
  background: var(--border-color);
}

/* 工作经验编辑区域样式 */
.experience-edit-container {
  position: relative;
}

.experience-date-error {
  padding: 8px 12px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: var(--radius-sm);
  color: var(--danger-color);
  font-size: 12px;
  margin-bottom: var(--space-sm);
}

.experience-edit-item {
  padding: var(--space-md);
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
  margin-bottom: var(--space-md);
  border: 1px solid var(--border-color);
}

.experience-edit-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-sm);
}

.experience-edit-index {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
}

.experience-delete-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  flex-shrink: 0;
}

.experience-delete-btn:hover {
  background: var(--danger-color);
  color: white;
}

.experience-delete-btn svg {
  width: 16px;
  height: 16px;
}

.experience-edit-row {
  display: flex;
  align-items: flex-start;
  gap: var(--space-sm);
  margin-bottom: var(--space-sm);
}

.experience-edit-row:last-child {
  margin-bottom: 0;
}

.experience-edit-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  padding-top: 8px;
  white-space: nowrap;
}

.experience-date-input {
  flex: 1 1;
  padding: 8px 12px;
  border: 2px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-family: inherit;
  transition: all var(--transition-fast);
}

.experience-date-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.1);
}

.experience-date-input::placeholder {
  color: var(--text-muted);
}

.experience-desc-textarea {
  flex: 1 1;
  padding: 8px 12px;
  border: 2px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-family: inherit;
  line-height: 1.5;
  resize: vertical;
  transition: all var(--transition-fast);
}

.experience-desc-textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.1);
}

.experience-edit-actions {
  margin-bottom: var(--space-sm);
}

.experience-add-btn {
  width: 100%;
  padding: 10px 16px;
  background: rgba(255, 111, 32, 0.1);
  color: var(--primary-color);
  border: 1px dashed var(--primary-color);
  border-radius: var(--radius-md);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);
  transition: all var(--transition-fast);
}

.experience-add-btn:hover {
  background: rgba(255, 111, 32, 0.2);
  border-color: var(--primary-hover);
}

.experience-add-btn svg {
  width: 16px;
  height: 16px;
}

.card-summary {
  font-size: 14px;
  color: var(--text-primary);
  line-height: 1.6;
  padding: var(--space-md);
  background: var(--bg-tertiary);
  border-radius: var(--radius-md);
}

/* 卡片操作区 */
.card-actions {
  padding: var(--space-lg) var(--space-xl);
  background: var(--bg-secondary);
  border-top: 1px solid var(--border-color);
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-sm);
}

.action-group {
  display: flex;
  gap: var(--space-xs);
  padding-right: var(--space-md);
  border-right: 1px solid var(--border-color);
  margin-right: var(--space-md);
}

.action-group:last-child {
  border-right: none;
  padding-right: 0;
  margin-right: 0;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);
  padding: 8px 14px;
  border: none;
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
}

.action-btn svg {
  width: 16px;
  height: 16px;
}

/* 功能按钮样式 */
.action-btn.edit {
  background: rgba(245, 158, 11, 0.1);
  color: var(--warning-color);
}

.action-btn.edit:hover {
  background: rgba(245, 158, 11, 0.2);
}

.action-btn.delete {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
}

.action-btn.delete:hover {
  background: rgba(239, 68, 68, 0.2);
}

.action-btn.photo {
  background: rgba(59, 130, 246, 0.1);
  color: var(--info-color);
}

.action-btn.photo:hover {
  background: rgba(59, 130, 246, 0.2);
}

.action-btn.chat {
  background: rgba(139, 92, 246, 0.1);
  color: var(--purple-color);
}

.action-btn.chat:hover {
  background: rgba(139, 92, 246, 0.2);
}

.action-btn.pdf {
  background: rgba(255, 111, 32, 0.1);
  color: var(--primary-color);
}

.action-btn.pdf:hover {
  background: rgba(255, 111, 32, 0.2);
}

.action-btn.view {
  background: rgba(249, 115, 22, 0.1);
  color: var(--orange-color);
}

.action-btn.view:hover {
  background: rgba(249, 115, 22, 0.2);
}

.action-btn.audio {
  background: rgba(236, 72, 153, 0.1);
  color: #db2777;
}

.action-btn.audio:hover {
  background: rgba(236, 72, 153, 0.2);
}

.action-btn.view-audio {
  background: rgba(147, 51, 234, 0.1);
  color: #9333ea;
}

.action-btn.view-audio:hover {
  background: rgba(147, 51, 234, 0.2);
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: var(--text-secondary);
}

.empty-state-icon {
  font-size: 72px;
  margin-bottom: var(--space-lg);
  opacity: 0.5;
}

.empty-state-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: var(--space-sm);
}

.empty-state-desc {
  font-size: 15px;
  color: var(--text-secondary);
}

/* ================================
   模态框 - 通用样式
   ================================ */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: var(--space-xl);
  animation: fadeIn var(--transition-base);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal {
  background: var(--bg-primary);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 520px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: var(--shadow-xl);
  animation: slideUp var(--transition-slow);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-xl) var(--space-2xl);
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-secondary);
}

.modal-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.modal-close {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: var(--bg-tertiary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  font-size: 24px;
  color: var(--text-secondary);
  line-height: 1;
}

.modal-close:hover {
  background: var(--danger-color);
  color: white;
}

.modal-body {
  padding: var(--space-2xl);
  overflow-y: auto;
  max-height: calc(90vh - 180px);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-md);
  padding: var(--space-lg) var(--space-2xl);
  border-top: 1px solid var(--border-color);
  background: var(--bg-secondary);
}

/* 表单样式 */
.form-group {
  margin-bottom: var(--space-lg);
}

.form-group:last-child {
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: var(--space-sm);
}

.form-label.required::after {
  content: ' *';
  color: var(--danger-color);
}

/* 标签样式 */
.tag {
  display: inline-block;
  padding: 4px 10px;
  background: var(--bg-tertiary);
  border-radius: var(--radius-sm);
  font-size: 12px;
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

/* 选择简历按钮 - 橙色主题 */
.btn-select-resume {
  background: linear-gradient(135deg, var(--primary-color), var(--info-color)) !important;
  color: white !important;
}

.btn-select-resume:hover {
  background: linear-gradient(135deg, var(--primary-hover), var(--primary-color)) !important;
}

/* 简历链接列表 */
.resume-link-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: var(--bg-primary);
  border-radius: var(--radius-sm);
  margin-top: 8px;
  border: 1px solid var(--border-color);
}

.resume-link {
  color: var(--primary-color);
  text-decoration: none;
  font-size: 13px;
  word-break: break-all;
  flex: 1 1;
}

.resume-link:hover {
  text-decoration: underline;
}

.resume-delete-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  flex-shrink: 0;
}

.resume-delete-btn:hover {
  background: var(--danger-color);
  color: white;
}

.resume-delete-btn svg {
  width: 16px;
  height: 16px;
}

.form-input,
.form-select {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 15px;
  font-family: inherit;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: all var(--transition-fast);
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px rgba(8, 145, 178, 0.1);
}

.form-input::placeholder {
  color: var(--text-muted);
}

/* 按钮 - 模态框 */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  padding: 12px 24px;
  border: none;
  border-radius: var(--radius-md);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-base);
}

.btn svg {
  width: 18px;
  height: 18px;
}

.btn-secondary {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.btn-secondary:hover {
  background: var(--border-color);
}

.btn-primary-modal {
  background: linear-gradient(135deg, var(--primary-color), var(--info-color));
  color: white;
  transform: translateY(-8px);
  box-shadow: var(--shadow-md);
}

.btn-primary-modal:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

/* ================================
   聊天图片查看器
   ================================ */
.chat-viewer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  padding: var(--space-2xl);
  animation: fadeIn var(--transition-base);
}

.chat-viewer {
  background: var(--bg-primary);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 1200px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: var(--shadow-xl);
  animation: slideUp var(--transition-slow);
  display: flex;
  flex-direction: column;
}

.chat-viewer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-lg) var(--space-xl);
  border-bottom: 1px solid var(--border-color);
}

.chat-viewer-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.chat-viewer-body {
  flex: 1 1;
  overflow-y: auto;
  padding: var(--space-xl);
  padding-bottom: 80px;
}

.chat-image-item {
  margin-bottom: var(--space-2xl);
  padding-bottom: var(--space-2xl);
  border-bottom: 1px solid var(--border-color);
  display: flex;
  gap: var(--space-xl);
  align-items: center;
}

.chat-image-item:last-child {
  margin-bottom: var(--space-xl);
  padding-bottom: 0;
  border-bottom: none;
}

.chat-image-wrapper {
  position: relative;
  width: 70%;
  height: 500px;
  background: var(--bg-tertiary);
  border-radius: var(--radius-lg);
  overflow: auto;
  margin-bottom: 0;
  flex-shrink: 0;
}

.image-pan-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  cursor: grab;
}

.image-pan-container.grabbing {
  cursor: grabbing;
}

.image-pan-content {
  position: relative;
  min-width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-pan-content img {
  max-width: none;
  max-height: none;
  display: block;
  -webkit-user-select: none;
          user-select: none;
  transition: transform 0.2s ease;
}

/* 图片缩放控制按钮 */
.image-zoom-controls {
  position: absolute;
  bottom: var(--space-md);
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: var(--space-sm);
  background: rgba(0, 0, 0, 0.7);
  border-radius: var(--radius-md);
  padding: var(--space-sm);
  z-index: 10;
}

.zoom-btn {
  width: 36px;
  height: 36px;
  border-radius: var(--radius-sm);
  border: none;
  background: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  color: var(--text-primary);
}

.zoom-btn:hover {
  background: white;
  transform: scale(1.1);
}

.zoom-btn svg {
  width: 20px;
  height: 20px;
}

.chat-image-actions {
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
  justify-content: center;
  padding-bottom: 0;
  min-width: 140px;
  align-items: center;
}

.chat-image-actions .btn:disabled {
  background: var(--bg-tertiary);
  color: var(--text-muted);
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* 删除聊天记录按钮 */
.btn-delete-chat {
  background: rgba(239, 68, 68, 0.1) !important;
  color: var(--danger-color) !important;
}

.btn-delete-chat:hover {
  background: var(--danger-color) !important;
  color: white !important;
}

/* ================================
   摘要编辑器
   ================================ */
.summary-editor-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1200;
  padding: var(--space-xl);
  animation: fadeIn var(--transition-base);
}

.summary-editor {
  background: var(--bg-primary);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 1000px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: var(--shadow-xl);
  animation: slideUp var(--transition-slow);
  display: flex;
  flex-direction: column;
}

.summary-editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-lg) var(--space-xl);
  border-bottom: 1px solid var(--border-color);
}

.summary-editor-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.summary-editor-content {
  display: flex;
  flex: 1 1;
  overflow: hidden;
}

.summary-editor-image {
  flex: 1 1;
  background: var(--bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-xl);
}

.summary-editor-image img {
  max-width: 100%;
  max-height: 500px;
  object-fit: contain;
  border-radius: var(--radius-md);
}

.summary-editor-text {
  flex: 1 1;
  padding: var(--space-xl);
  border-left: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
}

.summary-editor-textarea {
  flex: 1 1;
  width: 100%;
  padding: var(--space-lg);
  border: 2px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 15px;
  font-family: inherit;
  line-height: 1.7;
  resize: none;
  transition: all var(--transition-fast);
}

.summary-editor-textarea:focus {
  outline: none;
  border-color: var(--primary-color);
}

.summary-editor-footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-md);
  padding: var(--space-lg) var(--space-xl);
  border-top: 1px solid var(--border-color);
}

/* ================================
   上传遮罩
   ================================ */
.uploading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn var(--transition-base);
}

.uploading-content {
  text-align: center;
}

.uploading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--border-color);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto var(--space-lg);
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* 小 spinner 样式（用于按钮内） */
.spinner {
  animation: spin 1s linear infinite;
}

.uploading-text {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

/* ================================
   错误提示
   ================================ */
.error-banner {
  background: linear-gradient(135deg, #fee2e2, #fecaca);
  border: 1px solid #fca5a5;
  border-radius: var(--radius-md);
  padding: var(--space-lg);
  margin-bottom: var(--space-xl);
  display: flex;
  align-items: center;
  gap: var(--space-md);
  animation: slideUp var(--transition-base);
}

.error-banner svg {
  width: 24px;
  height: 24px;
  color: var(--danger-color);
  flex-shrink: 0;
}

.error-banner-text {
  font-size: 14px;
  color: #991b1b;
  font-weight: 500;
}

/* ================================
   响应式设计
   ================================ */
@media (max-width: 1024px) {
  .housekeepers-grid {
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  }
}

@media (max-width: 768px) {
  .container {
    padding: var(--space-lg);
  }

  .page-header {
    flex-direction: column;
    gap: var(--space-lg);
    text-align: center;
  }

  .page-title-section {
    flex-direction: column;
  }

  .housekeepers-grid {
    grid-template-columns: 1fr;
  }

  .stats-section {
    grid-template-columns: repeat(2, 1fr);
  }

  .search-section {
    flex-direction: column;
  }

  .summary-editor-content {
    flex-direction: column;
  }

  .summary-editor-image {
    max-height: 300px;
  }

  .card-actions {
    flex-direction: column;
  }

  .action-group {
    border-right: none;
    padding-right: 0;
    margin-right: 0;
    border-bottom: 1px solid var(--border-color);
    padding-bottom: var(--space-md);
    margin-bottom: var(--space-md);
  }
}

@media (max-width: 480px) {
  .stats-section {
    grid-template-columns: 1fr;
  }

  .stat-card {
    text-align: center;
  }

  .stat-icon {
    margin-left: auto;
    margin-right: auto;
  }
}

/* ================================
   工具类
   ================================ */
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.hidden {
  display: none !important;
}

/* ================================
   认证页面样式（登录/注册）
   ================================ */
.auth-page-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 50%, #fef3c7 100%);
  padding: var(--space-xl);
}

.auth-card {
  background: var(--bg-primary);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--border-color);
  width: 100%;
  max-width: 480px;
  overflow: hidden;
  animation: slideUp var(--transition-slow);
}

.auth-header {
  padding: var(--space-2xl) var(--space-2xl) var(--space-xl);
  text-align: center;
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-secondary);
}

.auth-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto var(--space-lg);
  background: linear-gradient(135deg, var(--primary-color), var(--info-color));
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-md);
}

.auth-icon svg {
  width: 32px;
  height: 32px;
  color: white;
}

.auth-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  letter-spacing: -0.5px;
}

.auth-subtitle {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 8px 0 0 0;
}

.auth-body {
  padding: var(--space-2xl);
}

.auth-footer {
  padding: var(--space-lg) var(--space-2xl);
  border-top: 1px solid var(--border-color);
  background: var(--bg-secondary);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-md);
}

.auth-footer > span {
  font-size: 14px;
  color: var(--text-secondary);
}

.auth-link {
  background: none;
  border: none;
  color: var(--primary-color);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);
}

.auth-link:hover {
  color: var(--primary-hover);
  text-decoration: underline;
}

.auth-link.back-home {
  color: var(--text-secondary);
}

.auth-link.back-home:hover {
  color: var(--text-primary);
}

.auth-link svg {
  width: 16px;
  height: 16px;
}

.auth-btn {
  width: 100%;
  padding: 14px;
  font-size: 16px;
  margin-top: var(--space-lg);
}

/* 密码输入框包装器 */
.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper .form-input {
  padding-right: 48px;
}

.password-toggle {
  position: absolute;
  right: var(--space-md);
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-xs);
  color: var(--text-muted);
  transition: all var(--transition-fast);
}

.password-toggle:hover {
  color: var(--primary-color);
}

.password-toggle svg {
  width: 20px;
  height: 20px;
}

/* 输入框错误状态 */
.input-error {
  border-color: var(--danger-color) !important;
}

.input-error:focus {
  border-color: var(--danger-color) !important;
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1) !important;
}

.error-text {
  display: block;
  font-size: 12px;
  color: var(--danger-color);
  margin-top: var(--space-xs);
}

/* 表单标签中的图标 */
.form-label svg {
  width: 16px;
  height: 16px;
  margin-right: var(--space-xs);
  vertical-align: middle;
}

.form-label {
  display: flex;
  align-items: center;
}

/* 响应式设计 */
/* ================================
   用户头像按钮（头部）
   ================================ */
.user-avatar-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid var(--border-color);
  background: var(--bg-primary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  overflow: hidden;
  padding: 0;
}

.user-avatar-btn:hover {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px var(--primary-light);
}

.user-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
}

.user-avatar-placeholder svg {
  width: 24px;
  height: 24px;
}

/* ================================
   用户信息编辑页面（移动端设计）
   ================================ */
.user-profile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 1300;
  padding: 0;
  animation: fadeIn var(--transition-base);
}

.user-profile-modal {
  background: var(--bg-primary);
  border-radius: var(--radius-xl) var(--radius-xl) 0 0;
  width: 100%;
  max-width: 520px;
  max-height: 85vh;
  overflow: hidden;
  box-shadow: var(--shadow-xl);
  animation: slideUp var(--transition-slow);
  display: flex;
  flex-direction: column;
}

.user-profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-lg) var(--space-xl);
  border-bottom: 1px solid var(--border-color);
  background: var(--bg-secondary);
}

.user-profile-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.user-profile-close {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: var(--bg-tertiary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  color: var(--text-secondary);
}

.user-profile-close:hover {
  background: var(--danger-color);
  color: white;
}

.user-profile-close svg {
  width: 20px;
  height: 20px;
}

.user-profile-body {
  flex: 1 1;
  overflow-y: auto;
  padding: var(--space-xl);
}

.profile-section {
  margin-bottom: var(--space-xl);
}

.profile-section-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: var(--space-lg);
  padding-bottom: var(--space-sm);
  border-bottom: 2px solid var(--primary-light);
}

.profile-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: var(--space-sm);
}

.profile-input,
.profile-select {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 15px;
  font-family: inherit;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: all var(--transition-fast);
}

.profile-input:focus,
.profile-select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px rgba(8, 145, 178, 0.1);
}

.profile-input::placeholder {
  color: var(--text-muted);
}

/* 头像上传按钮 */
.avatar-upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-sm);
}

.avatar-upload-btn {
  width: 100px;
  height: 100px;
  border-radius: var(--radius-lg);
  border: 3px dashed var(--border-color);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-fast);
  overflow: hidden;
  background: var(--bg-secondary);
}

.avatar-upload-btn:hover {
  border-color: var(--primary-color);
  background: var(--primary-light);
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
}

.avatar-placeholder svg {
  width: 40px;
  height: 40px;
}

.avatar-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.uploading-hint {
  font-size: 12px;
  color: var(--text-secondary);
}

/* 身份证上传按钮 */
.idcard-upload-container {
  display: flex;
  gap: var(--space-lg);
  justify-content: center;
}

.idcard-upload-btn {
  flex: 1 1;
  max-width: 140px;
  padding: var(--space-lg);
  border-radius: var(--radius-md);
  border: 2px dashed var(--border-color);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
  background: var(--bg-secondary);
}

.idcard-upload-btn:hover {
  border-color: var(--primary-color);
  background: var(--primary-light);
}

.idcard-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
}

.idcard-icon svg {
  width: 40px;
  height: 40px;
}

.idcard-label {
  font-size: 12px;
  color: var(--text-secondary);
  text-align: center;
}

.idcard-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--radius-sm);
}

/* 底部按钮 */
.user-profile-footer {
  display: flex;
  justify-content: center;
  gap: var(--space-lg);
  padding: var(--space-lg) var(--space-xl);
  border-top: 1px solid var(--border-color);
  background: var(--bg-secondary);
}

.btn-profile-cancel,
.btn-profile-save {
  flex: 1 1;
  max-width: 140px;
  padding: 12px 24px;
  border: none;
  border-radius: var(--radius-md);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-base);
}

.btn-profile-cancel {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.btn-profile-cancel:hover {
  background: var(--border-color);
}

.btn-profile-save {
  background: linear-gradient(135deg, var(--primary-color), var(--info-color));
  color: white;
}

.btn-profile-save:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.btn-profile-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* 修改密码区域 */
.btn-change-password {
  margin-top: 16px;
  width: 100%;
  padding: 12px 24px;
  background: linear-gradient(135deg, var(--primary-color), var(--info-color));
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-base);
}

.btn-change-password:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.btn-change-password:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* 密码输入框在 profile 中的样式 */
.profile-section .password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.profile-section .password-input-wrapper .profile-input {
  padding-right: 48px;
}

.profile-section .password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: var(--text-muted);
  transition: all var(--transition-fast);
}

.profile-section .password-toggle:hover {
  color: var(--primary-color);
}

.profile-section .password-toggle svg {
  width: 20px;
  height: 20px;
}

/* 加载状态 */
.loading-state {
  padding: var(--space-2xl);
  text-align: center;
  color: var(--text-secondary);
  font-size: 16px;
}

/* 移动端适配 */
@media (max-width: 480px) {
  .auth-card {
    max-width: 100%;
  }

  .auth-header,
  .auth-body,
  .auth-footer {
    padding: var(--space-xl);
  }

  .user-profile-overlay {
    align-items: flex-end;
  }

  .user-profile-modal {
    max-height: 90vh;
    border-radius: var(--radius-xl) var(--radius-xl) 0 0;
  }

  .user-profile-body {
    max-height: calc(90vh - 140px);
  }

  .idcard-upload-container {
    flex-direction: row;
  }

  .idcard-upload-btn {
    max-width: none;
    padding: var(--space-md);
  }
}

/* ================================
   照片编辑器
   ================================ */
.photo-editor-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
  padding: var(--space-xl);
  animation: fadeIn var(--transition-base);
}

.photo-editor {
  background: var(--bg-primary);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: var(--shadow-xl);
  animation: slideUp var(--transition-slow);
  display: flex;
  flex-direction: column;
}

.photo-editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-lg) var(--space-xl);
  border-bottom: 1px solid var(--border-color);
}

.photo-editor-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.photo-editor-body {
  flex: 1 1;
  overflow-y: auto;
  padding: var(--space-xl);
}

.photo-editor-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: var(--space-lg);
}

.photo-editor-item {
  position: relative;
}

.photo-editor-image-wrapper {
  position: relative;
  aspect-ratio: 1;
  border-radius: var(--radius-md);
  overflow: hidden;
  border: 2px solid var(--border-color);
}

.photo-editor-image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-editor-delete-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: rgba(239, 68, 68, 0.9);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all var(--transition-fast);
  z-index: 10;
}

.photo-editor-image-wrapper:hover .photo-editor-delete-btn {
  opacity: 1;
}

.photo-editor-delete-btn:hover {
  background: var(--danger-color);
  transform: translate(-50%, -50%) scale(1.1);
}

.photo-editor-delete-btn svg {
  width: 24px;
  height: 24px;
}

.photo-editor-replace-btn {
  width: 100%;
  padding: 8px;
  margin-top: var(--space-sm);
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.photo-editor-replace-btn:hover {
  background: var(--border-color);
}

.photo-editor-upload-slot {
  aspect-ratio: 1;
  border-radius: var(--radius-md);
  border: 2px dashed var(--border-color);
  background: var(--bg-secondary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.photo-editor-upload-slot:hover {
  border-color: var(--primary-color);
  background: var(--primary-light);
}

.photo-editor-upload-slot svg {
  width: 32px;
  height: 32px;
  color: var(--primary-color);
}

.photo-editor-upload-slot span {
  font-size: 13px;
  color: var(--text-secondary);
}

.photo-editor-add-slot {
  aspect-ratio: 1;
  border-radius: var(--radius-md);
  border: 2px dashed var(--primary-color);
  background: var(--primary-light);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.photo-editor-add-slot:hover {
  background: rgba(8, 145, 178, 0.15);
}

.photo-editor-add-slot svg {
  width: 32px;
  height: 32px;
  color: var(--primary-color);
}

.photo-editor-add-slot span {
  font-size: 13px;
  color: var(--primary-color);
  font-weight: 500;
}

.photo-editor-footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-md);
  padding: var(--space-lg) var(--space-xl);
  border-top: 1px solid var(--border-color);
}

/* ================================
   内联照片编辑样式
   ================================ */
.photo-inline-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-md);
  padding: var(--space-md) 0;
  margin-top: var(--space-sm);
  border-top: 1px solid var(--border-color);
}

.photo-grid-add {
  border: 2px dashed var(--primary-color);
  background: var(--primary-light);
  cursor: pointer;
  transition: all var(--transition-fast);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
}

.photo-grid-add:hover {
  background: rgba(8, 145, 178, 0.15);
}

.photo-grid-add svg {
  width: 32px;
  height: 32px;
  color: var(--primary-color);
}

.photo-grid-add span {
  font-size: 13px;
  color: var(--primary-color);
  font-weight: 500;
}

.photo-delete-inline {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(239, 68, 68, 0.95);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: all var(--transition-fast);
  z-index: 10;
  box-shadow: var(--shadow-md);
}

.photo-delete-inline:hover {
  background: var(--danger-color);
  transform: scale(1.1);
}

.photo-delete-inline svg {
  width: 18px;
  height: 18px;
}

.photo-upload-inline {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: rgba(8, 145, 178, 0.9);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  z-index: 10;
  box-shadow: var(--shadow-md);
}

.photo-upload-inline:hover {
  background: var(--primary-hover);
  transform: translate(-50%, -50%) scale(1.1);
}

.photo-upload-inline svg {
  width: 24px;
  height: 24px;
}

/* 编辑状态下的图片容器 - 需要position:relative以支持浮层按钮 */
.photo-grid-editing {
  position: relative;
}

/* 中间位置的删除按钮 */
.photo-delete-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: rgba(239, 68, 68, 0.9);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  z-index: 10;
  box-shadow: var(--shadow-md);
}

.photo-delete-center:hover {
  background: var(--danger-color);
  transform: translate(-50%, -50%) scale(1.1);
}

.photo-delete-center svg {
  width: 24px;
  height: 24px;
}

/* 空白添加区域样式 - 带虚线边框 */
.photo-grid-add-center {
  border: 2px dashed var(--primary-color);
  background: rgba(8, 145, 178, 0.08);
  cursor: pointer;
  transition: all var(--transition-fast);
  position: relative;
}

.photo-grid-add-center:hover {
  background: rgba(8, 145, 178, 0.15);
}

/* 中间位置的添加按钮 */
.photo-add-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: rgba(8, 145, 178, 0.9);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  z-index: 10;
  box-shadow: var(--shadow-md);
}

.photo-add-center:hover {
  background: var(--primary-hover);
  transform: translate(-50%, -50%) scale(1.1);
}

.photo-add-center svg {
  width: 24px;
  height: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;qCAGqC;;AAErC,kBAAkB;AAClB;EACE,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,QAAQ;EACR,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;;EAEvB,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;;EAEtB,OAAO;EACP,0CAA0C;EAC1C,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;;EAEtF,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,OAAO;EACP,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;;EAEjB,OAAO;EACP,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,SAAS;AACT;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,qIAAqI;EACrI,mCAAmC;EACnC,kCAAkC;EAClC,0EAA0E;EAC1E,iBAAiB;AACnB;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;;qCAEqC;AACrC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;EACzC,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4EAA4E;EAC5E,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,4EAA4E;EAC5E,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;qCAEqC;AACrC;EACE,aAAa;EACb,2DAA2D;EAC3D,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,8BAA8B;AAChC;;AAEA,kBAAkB,gCAAgC,EAAE;AACpD,mBAAmB,mBAAmB,EAAE;AACxC,oBAAoB,mBAAmB,EAAE;AACzC,oBAAoB,mBAAmB,EAAE;;AAEzC;EACE,eAAe;EACf,4BAA4B;EAC5B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;;qCAEqC;AACrC;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;;qCAEqC;AACrC;EACE,aAAa;EACb,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,2EAA2E;EAC3E,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA,oBAAoB,mBAAmB,EAAE;AACzC,sBAAsB,mBAAmB,EAAE;AAC3C,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA,yBAAyB,mBAAmB,EAAE;AAC9C,uBAAuB,mBAAmB,EAAE;;AAE5C;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB,4CAA4C;EAC5C,qEAAqE;EACrE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,iBAAiB;EACjB,mCAAmC;EACnC,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,6EAA6E;EAC7E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,sCAAsC;EACtC,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA,eAAe;AACf;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,WAAW;AACX;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,2BAA2B;EAC3B,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;EACxB,qDAAqD;EACrD,yBAAyB;EACzB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,2BAA2B;EAC3B,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,4EAA4E;EAC5E,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,wCAAwC;EACxC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,2BAA2B;EAC3B,uCAAuC;EACvC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA,UAAU;AACV;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,yCAAyC;EACzC,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,WAAW;AACX;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yCAAyC;EACzC,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,yCAAyC;EACzC,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA,SAAS;AACT;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA,kBAAkB;AAClB;EACE,uFAAuF;EACvF,uBAAuB;AACzB;;AAEA;EACE,0FAA0F;AAC5F;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,SAAO;AACT;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4EAA4E;EAC5E,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,4CAA4C;EAC5C,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,+BAA+B;EAC/B,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,wBAAwB;EACxB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,wBAAwB;EACxB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;qCAEqC;AACrC;EACE,qDAAqD;EACrD,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;EACxB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;qCAEqC;AACrC;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,4CAA4C;IAC5C,+BAA+B;IAC/B,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;;qCAEqC;AACrC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;qCAEqC;AACrC;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0EAA0E;EAC1E,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,4EAA4E;EAC5E,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,uDAAuD;AACzD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,UAAU;AACV;;qCAEqC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,oDAAoD;EACpD,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,wBAAwB;EACxB,+BAA+B;EAC/B,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,wCAAwC;EACxC,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;;EAEE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4EAA4E;EAC5E,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,4EAA4E;EAC5E,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,SAAS;AACT;EACE,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,UAAU;AACV;EACE;IACE,eAAe;EACjB;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,oDAAoD;EACtD;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,wBAAwB;EAC1B;AACF;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,sCAAsC;EACtC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,uCAAuC;EACvC,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;;qCAEqC;AACrC;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;EACnC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,sCAAsC;EACtC,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,uCAAuC;EACvC,mCAAmC;EACnC,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["/* ================================\n   家政管理系统 - 现代化重新设计\n   设计理念：清新、专业、易用\n   ================================ */\n\n/* CSS 变量 - 设计系统 */\n:root {\n  /* 主色调 - 暖橙色系（与小程序一致） */\n  --primary-color: #ff6f20;\n  --primary-hover: #e65a10;\n  --primary-light: #fff7ed;\n\n  /* 功能色 */\n  --success-color: #10b981;\n  --success-hover: #059669;\n  --warning-color: #f59e0b;\n  --danger-color: #ef4444;\n  --danger-hover: #dc2626;\n  --info-color: #ff6f20;\n  --purple-color: #8b5cf6;\n  --orange-color: #f97316;\n\n  /* 中性色 */\n  --text-primary: #1f2937;\n  --text-secondary: #6b7280;\n  --text-muted: #9ca3af;\n  --border-color: #e5e7eb;\n  --bg-primary: #ffffff;\n  --bg-secondary: #f9fafb;\n  --bg-tertiary: #f3f4f6;\n\n  /* 阴影 */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n\n  /* 圆角 */\n  --radius-sm: 6px;\n  --radius-md: 10px;\n  --radius-lg: 16px;\n  --radius-xl: 24px;\n\n  /* 间距 */\n  --space-xs: 4px;\n  --space-sm: 8px;\n  --space-md: 12px;\n  --space-lg: 16px;\n  --space-xl: 24px;\n  --space-2xl: 32px;\n\n  /* 过渡 */\n  --transition-fast: 150ms ease;\n  --transition-base: 200ms ease;\n  --transition-slow: 300ms ease;\n}\n\n/* 全局重置 */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 50%, #fef3c7 100%);\n  min-height: 100vh;\n}\n\n/* ================================\n   主容器 - 手机样式居中展示（屏幕1/3宽度）\n   ================================ */\n.container {\n  max-width: 33.33vw;\n  margin: 0 auto;\n  padding: 0;\n  min-height: 100vh;\n  background: var(--bg-secondary);\n  box-shadow: 0 0 40px rgba(0,0,0,0.08);\n}\n\n/* ================================\n   页面头部\n   ================================ */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--space-2xl);\n  padding: var(--space-xl) var(--space-2xl);\n  background: var(--bg-primary);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-color);\n}\n\n.page-title-section {\n  display: flex;\n  align-items: center;\n  gap: var(--space-lg);\n}\n\n.page-icon {\n  width: 56px;\n  height: 56px;\n  background: linear-gradient(135deg, var(--primary-color), var(--info-color));\n  border-radius: var(--radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  box-shadow: var(--shadow-md);\n}\n\n.page-title {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -0.5px;\n}\n\n.page-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n/* 主按钮样式 */\n.btn-primary {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-sm);\n  padding: 12px 24px;\n  background: linear-gradient(135deg, var(--primary-color), var(--info-color));\n  color: white;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-base);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-primary:active {\n  transform: translateY(0);\n}\n\n.btn-primary svg {\n  width: 20px;\n  height: 20px;\n}\n\n/* ================================\n   统计卡片区域\n   ================================ */\n.stats-section {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: var(--space-lg);\n  margin-bottom: var(--space-2xl);\n}\n\n.stat-card {\n  background: var(--bg-primary);\n  padding: var(--space-xl);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border-color);\n  transition: all var(--transition-base);\n}\n\n.stat-card:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n.stat-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  margin-bottom: var(--space-md);\n}\n\n.stat-icon.blue { background: var(--primary-light); }\n.stat-icon.green { background: #ecfdf5; }\n.stat-icon.orange { background: #fff7ed; }\n.stat-icon.purple { background: #f5f3ff; }\n\n.stat-label {\n  font-size: 13px;\n  color: var(--text-secondary);\n  margin-bottom: var(--space-xs);\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -1px;\n}\n\n/* ================================\n   搜索和筛选栏\n   ================================ */\n.search-section {\n  display: flex;\n  gap: var(--space-md);\n  margin-bottom: var(--space-xl);\n}\n\n.search-input-wrapper {\n  flex: 1;\n  position: relative;\n}\n\n.search-input-wrapper svg {\n  position: absolute;\n  left: var(--space-lg);\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  color: var(--text-muted);\n}\n\n.search-input {\n  width: 100%;\n  padding: 14px var(--space-lg) 14px 48px;\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-md);\n  font-size: 15px;\n  background: var(--bg-primary);\n  transition: all var(--transition-fast);\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 4px rgba(8, 145, 178, 0.1);\n}\n\n.filter-select {\n  padding: 14px var(--space-xl);\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-md);\n  font-size: 15px;\n  background: var(--bg-primary);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n/* ================================\n   阿姨卡片网格\n   ================================ */\n.housekeepers-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));\n  gap: var(--space-xl);\n}\n\n/* 阿姨卡片 */\n.housekeeper-card {\n  background: var(--bg-primary);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-color);\n  overflow: hidden;\n  transition: all var(--transition-slow);\n  position: relative;\n}\n\n.housekeeper-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--primary-color), var(--info-color));\n  opacity: 0;\n  transition: opacity var(--transition-base);\n}\n\n.housekeeper-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-xl);\n}\n\n.housekeeper-card:hover::before {\n  opacity: 1;\n}\n\n/* 卡片状态样式 */\n.card-unpublished {\n  background: #e0f0ff !important;\n}\n\n.card-published {\n  background: var(--bg-primary) !important;\n}\n\n.card-status-badge {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 10;\n}\n\n.status-tag {\n  font-size: 12px;\n  padding: 4px 8px;\n  border-radius: 8px;\n  color: #fff;\n}\n\n.status-tag.draft { background: #9ca3af; }\n.status-tag.pending { background: #f59e0b; }\n.status-tag.published { background: #ff6f20; }\n\n.share-btn-card {\n  background: #ff6f20;\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  padding: 4px 8px;\n  font-size: 14px;\n  cursor: pointer;\n  margin-left: 8px;\n}\n\n/* 分享弹窗 */\n.share-modal-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.share-modal {\n  background: #fff;\n  border-radius: 20px;\n  padding: 32px;\n  width: 400px;\n  text-align: center;\n}\n\n.share-modal-title {\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 24px;\n}\n\n.share-options {\n  display: flex;\n  justify-content: space-around;\n  margin-bottom: 24px;\n}\n\n.share-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.share-icon-box {\n  width: 60px;\n  height: 60px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  color: #fff;\n}\n\n.share-icon-box.wechat { background: #07c160; }\n.share-icon-box.link { background: #ff6f20; }\n\n.share-option-label {\n  font-size: 14px;\n  color: #4b5563;\n}\n\n/* 卡片头部 */\n.card-header {\n  display: flex;\n  padding: var(--space-xl);\n  gap: var(--space-lg);\n  border-bottom: 1px solid var(--border-color);\n  background: linear-gradient(180deg, var(--bg-secondary), transparent);\n  align-items: flex-start;\n}\n\n.card-photo-wrapper {\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.card-photo {\n  width: 100px;\n  height: 100px;\n  border-radius: var(--radius-lg);\n  object-fit: cover;\n  border: 3px solid var(--bg-primary);\n  box-shadow: var(--shadow-md);\n  background: var(--bg-tertiary);\n}\n\n.card-photo-placeholder {\n  width: 100px;\n  height: 100px;\n  border-radius: var(--radius-lg);\n  background: linear-gradient(135deg, var(--primary-light), var(--bg-tertiary));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 40px;\n  border: 3px solid var(--bg-primary);\n  box-shadow: var(--shadow-md);\n}\n\n.card-photo-upload {\n  position: absolute;\n  bottom: -4px;\n  right: -4px;\n  width: 32px;\n  height: 32px;\n  background: var(--primary-color);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: var(--shadow-md);\n  transition: all var(--transition-fast);\n  border: 2px solid var(--bg-primary);\n  z-index: 10;\n}\n\n.card-photo-upload:hover {\n  background: var(--primary-hover);\n  transform: scale(1.1);\n}\n\n.card-photo-upload svg {\n  width: 18px;\n  height: 18px;\n  color: white;\n}\n\n/* 新的卡片信息区域样式 */\n.card-info-new {\n  flex: 1;\n  min-width: 0;\n  padding-top: 4px;\n}\n\n.card-name-row-new {\n  display: flex;\n  align-items: center;\n  gap: var(--space-md);\n  margin-bottom: var(--space-md);\n}\n\n.card-name-new {\n  font-size: 22px;\n  font-weight: 800;\n  color: #000000;\n  margin: 0;\n  letter-spacing: -0.3px;\n}\n\n.card-info-details-new {\n  font-size: 14px;\n  color: var(--text-secondary);\n  line-height: 1.8;\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-sm);\n}\n\n.card-info-details-new .phone-line {\n  width: 100%;\n  margin-top: 2px;\n}\n\n/* 标签展示区域 - 头像正下方 */\n.card-labels-section-outside {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-sm);\n  padding: var(--space-md) var(--space-xl) 0;\n  align-items: center;\n}\n\n.label-tag-green {\n  display: inline-block;\n  padding: 4px 10px;\n  color: #ff6f20;\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  font-weight: 500;\n  background: rgba(255, 111, 32, 0.1);\n}\n\n/* 照片展示区域 */\n.photo-display-section {\n  margin-bottom: var(--space-lg);\n}\n\n.photo-section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--space-sm);\n}\n\n.photo-edit-btn {\n  padding: 4px 8px;\n  background: rgba(255, 111, 32, 0.1);\n  color: var(--primary-color);\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  font-size: 12px;\n  gap: 4px;\n}\n\n.photo-edit-btn:hover {\n  background: rgba(255, 111, 32, 0.2);\n}\n\n.photo-edit-btn svg {\n  width: 14px;\n  height: 14px;\n}\n\n.photo-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: var(--space-md);\n}\n\n.photo-grid-item {\n  aspect-ratio: 1;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-color);\n}\n\n.photo-grid-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.photo-grid-empty {\n  aspect-ratio: 1;\n  border-radius: var(--radius-md);\n  background: var(--bg-tertiary);\n  border: 1px dashed var(--border-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  font-size: 12px;\n}\n\n/* 卡片内容 */\n.card-body {\n  padding: var(--space-xl);\n}\n\n.card-section {\n  margin-bottom: var(--space-lg);\n}\n\n.card-section:last-child {\n  margin-bottom: 0;\n}\n\n.card-section-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: var(--space-sm);\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n}\n\n.card-section-label svg {\n  width: 14px;\n  height: 14px;\n}\n\n.card-address {\n  font-size: 14px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  padding: var(--space-md);\n  background: var(--bg-secondary);\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-sm);\n}\n\n.card-address svg {\n  width: 16px;\n  height: 16px;\n  color: var(--text-muted);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n/* 工作经验样式 */\n.card-experience {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n}\n\n.experience-item {\n  padding: var(--space-md);\n  background: var(--bg-secondary);\n  border-radius: var(--radius-md);\n  border-left: 3px solid var(--primary-color);\n}\n\n.experience-date {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--primary-color);\n  margin-bottom: var(--space-xs);\n}\n\n.experience-desc {\n  font-size: 14px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n\n.card-text {\n  font-size: 14px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  padding: var(--space-md);\n  background: var(--bg-secondary);\n  border-radius: var(--radius-md);\n}\n\n.card-summary {\n  font-size: 14px;\n  color: var(--text-secondary);\n  line-height: 1.7;\n  padding: var(--space-md);\n  background: linear-gradient(135deg, #fffbeb, #fef3c7);\n  border: 1px solid #fde68a;\n  border-radius: var(--radius-md);\n  max-height: 100px;\n  overflow-y: auto;\n  white-space: pre-wrap;\n}\n\n.card-summary-empty {\n  font-style: italic;\n  color: var(--text-muted);\n}\n\n/* 自我介绍编辑区域样式 */\n.self-intro-edit-container {\n  position: relative;\n}\n\n.self-intro-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--space-sm);\n}\n\n.self-intro-edit-btn {\n  padding: 4px 8px;\n  background: rgba(255, 111, 32, 0.1);\n  color: var(--primary-color);\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  font-size: 12px;\n  gap: 4px;\n}\n\n.self-intro-edit-btn:hover {\n  background: rgba(255, 111, 32, 0.2);\n}\n\n.self-intro-edit-btn svg {\n  width: 14px;\n  height: 14px;\n}\n\n.self-intro-textarea {\n  width: 100%;\n  padding: var(--space-md);\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  font-family: inherit;\n  line-height: 1.6;\n  resize: vertical;\n  min-height: 80px;\n  transition: all var(--transition-fast);\n}\n\n.self-intro-textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.1);\n}\n\n.self-intro-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--space-sm);\n  margin-top: var(--space-sm);\n}\n\n.self-intro-save-btn,\n.self-intro-cancel-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.self-intro-save-btn {\n  background: linear-gradient(135deg, var(--primary-color), var(--info-color));\n  color: white;\n}\n\n.self-intro-save-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.self-intro-cancel-btn {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.self-intro-cancel-btn:hover {\n  background: var(--border-color);\n}\n\n/* 工作经验编辑区域样式 */\n.experience-edit-container {\n  position: relative;\n}\n\n.experience-date-error {\n  padding: 8px 12px;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: var(--radius-sm);\n  color: var(--danger-color);\n  font-size: 12px;\n  margin-bottom: var(--space-sm);\n}\n\n.experience-edit-item {\n  padding: var(--space-md);\n  background: var(--bg-secondary);\n  border-radius: var(--radius-md);\n  margin-bottom: var(--space-md);\n  border: 1px solid var(--border-color);\n}\n\n.experience-edit-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--space-sm);\n}\n\n.experience-edit-index {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.experience-delete-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger-color);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  flex-shrink: 0;\n}\n\n.experience-delete-btn:hover {\n  background: var(--danger-color);\n  color: white;\n}\n\n.experience-delete-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.experience-edit-row {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-sm);\n  margin-bottom: var(--space-sm);\n}\n\n.experience-edit-row:last-child {\n  margin-bottom: 0;\n}\n\n.experience-edit-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  padding-top: 8px;\n  white-space: nowrap;\n}\n\n.experience-date-input {\n  flex: 1;\n  padding: 8px 12px;\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  font-family: inherit;\n  transition: all var(--transition-fast);\n}\n\n.experience-date-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.1);\n}\n\n.experience-date-input::placeholder {\n  color: var(--text-muted);\n}\n\n.experience-desc-textarea {\n  flex: 1;\n  padding: 8px 12px;\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  font-family: inherit;\n  line-height: 1.5;\n  resize: vertical;\n  transition: all var(--transition-fast);\n}\n\n.experience-desc-textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.1);\n}\n\n.experience-edit-actions {\n  margin-bottom: var(--space-sm);\n}\n\n.experience-add-btn {\n  width: 100%;\n  padding: 10px 16px;\n  background: rgba(255, 111, 32, 0.1);\n  color: var(--primary-color);\n  border: 1px dashed var(--primary-color);\n  border-radius: var(--radius-md);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-xs);\n  transition: all var(--transition-fast);\n}\n\n.experience-add-btn:hover {\n  background: rgba(255, 111, 32, 0.2);\n  border-color: var(--primary-hover);\n}\n\n.experience-add-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.card-summary {\n  font-size: 14px;\n  color: var(--text-primary);\n  line-height: 1.6;\n  padding: var(--space-md);\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-md);\n}\n\n/* 卡片操作区 */\n.card-actions {\n  padding: var(--space-lg) var(--space-xl);\n  background: var(--bg-secondary);\n  border-top: 1px solid var(--border-color);\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-sm);\n}\n\n.action-group {\n  display: flex;\n  gap: var(--space-xs);\n  padding-right: var(--space-md);\n  border-right: 1px solid var(--border-color);\n  margin-right: var(--space-md);\n}\n\n.action-group:last-child {\n  border-right: none;\n  padding-right: 0;\n  margin-right: 0;\n}\n\n.action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-xs);\n  padding: 8px 14px;\n  border: none;\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  white-space: nowrap;\n}\n\n.action-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* 功能按钮样式 */\n.action-btn.edit {\n  background: rgba(245, 158, 11, 0.1);\n  color: var(--warning-color);\n}\n\n.action-btn.edit:hover {\n  background: rgba(245, 158, 11, 0.2);\n}\n\n.action-btn.delete {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger-color);\n}\n\n.action-btn.delete:hover {\n  background: rgba(239, 68, 68, 0.2);\n}\n\n.action-btn.photo {\n  background: rgba(59, 130, 246, 0.1);\n  color: var(--info-color);\n}\n\n.action-btn.photo:hover {\n  background: rgba(59, 130, 246, 0.2);\n}\n\n.action-btn.chat {\n  background: rgba(139, 92, 246, 0.1);\n  color: var(--purple-color);\n}\n\n.action-btn.chat:hover {\n  background: rgba(139, 92, 246, 0.2);\n}\n\n.action-btn.pdf {\n  background: rgba(255, 111, 32, 0.1);\n  color: var(--primary-color);\n}\n\n.action-btn.pdf:hover {\n  background: rgba(255, 111, 32, 0.2);\n}\n\n.action-btn.view {\n  background: rgba(249, 115, 22, 0.1);\n  color: var(--orange-color);\n}\n\n.action-btn.view:hover {\n  background: rgba(249, 115, 22, 0.2);\n}\n\n.action-btn.audio {\n  background: rgba(236, 72, 153, 0.1);\n  color: #db2777;\n}\n\n.action-btn.audio:hover {\n  background: rgba(236, 72, 153, 0.2);\n}\n\n.action-btn.view-audio {\n  background: rgba(147, 51, 234, 0.1);\n  color: #9333ea;\n}\n\n.action-btn.view-audio:hover {\n  background: rgba(147, 51, 234, 0.2);\n}\n\n/* 空状态 */\n.empty-state {\n  text-align: center;\n  padding: 80px 20px;\n  color: var(--text-secondary);\n}\n\n.empty-state-icon {\n  font-size: 72px;\n  margin-bottom: var(--space-lg);\n  opacity: 0.5;\n}\n\n.empty-state-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: var(--space-sm);\n}\n\n.empty-state-desc {\n  font-size: 15px;\n  color: var(--text-secondary);\n}\n\n/* ================================\n   模态框 - 通用样式\n   ================================ */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: var(--space-xl);\n  animation: fadeIn var(--transition-base);\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.modal {\n  background: var(--bg-primary);\n  border-radius: var(--radius-xl);\n  width: 100%;\n  max-width: 520px;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: var(--shadow-xl);\n  animation: slideUp var(--transition-slow);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--space-xl) var(--space-2xl);\n  border-bottom: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n}\n\n.modal-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.modal-close {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: none;\n  background: var(--bg-tertiary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  font-size: 24px;\n  color: var(--text-secondary);\n  line-height: 1;\n}\n\n.modal-close:hover {\n  background: var(--danger-color);\n  color: white;\n}\n\n.modal-body {\n  padding: var(--space-2xl);\n  overflow-y: auto;\n  max-height: calc(90vh - 180px);\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--space-md);\n  padding: var(--space-lg) var(--space-2xl);\n  border-top: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n}\n\n/* 表单样式 */\n.form-group {\n  margin-bottom: var(--space-lg);\n}\n\n.form-group:last-child {\n  margin-bottom: 0;\n}\n\n.form-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: var(--space-sm);\n}\n\n.form-label.required::after {\n  content: ' *';\n  color: var(--danger-color);\n}\n\n/* 标签样式 */\n.tag {\n  display: inline-block;\n  padding: 4px 10px;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n}\n\n/* 选择简历按钮 - 橙色主题 */\n.btn-select-resume {\n  background: linear-gradient(135deg, var(--primary-color), var(--info-color)) !important;\n  color: white !important;\n}\n\n.btn-select-resume:hover {\n  background: linear-gradient(135deg, var(--primary-hover), var(--primary-color)) !important;\n}\n\n/* 简历链接列表 */\n.resume-link-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: var(--bg-primary);\n  border-radius: var(--radius-sm);\n  margin-top: 8px;\n  border: 1px solid var(--border-color);\n}\n\n.resume-link {\n  color: var(--primary-color);\n  text-decoration: none;\n  font-size: 13px;\n  word-break: break-all;\n  flex: 1;\n}\n\n.resume-link:hover {\n  text-decoration: underline;\n}\n\n.resume-delete-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger-color);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  flex-shrink: 0;\n}\n\n.resume-delete-btn:hover {\n  background: var(--danger-color);\n  color: white;\n}\n\n.resume-delete-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.form-input,\n.form-select {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-md);\n  font-size: 15px;\n  font-family: inherit;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: all var(--transition-fast);\n}\n\n.form-input:focus,\n.form-select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 4px rgba(8, 145, 178, 0.1);\n}\n\n.form-input::placeholder {\n  color: var(--text-muted);\n}\n\n/* 按钮 - 模态框 */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n  padding: 12px 24px;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-base);\n}\n\n.btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n.btn-secondary {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.btn-secondary:hover {\n  background: var(--border-color);\n}\n\n.btn-primary-modal {\n  background: linear-gradient(135deg, var(--primary-color), var(--info-color));\n  color: white;\n  transform: translateY(-8px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-primary-modal:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n/* ================================\n   聊天图片查看器\n   ================================ */\n.chat-viewer-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(8px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1100;\n  padding: var(--space-2xl);\n  animation: fadeIn var(--transition-base);\n}\n\n.chat-viewer {\n  background: var(--bg-primary);\n  border-radius: var(--radius-xl);\n  width: 100%;\n  max-width: 1200px;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: var(--shadow-xl);\n  animation: slideUp var(--transition-slow);\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-viewer-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--space-lg) var(--space-xl);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.chat-viewer-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.chat-viewer-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: var(--space-xl);\n  padding-bottom: 80px;\n}\n\n.chat-image-item {\n  margin-bottom: var(--space-2xl);\n  padding-bottom: var(--space-2xl);\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  gap: var(--space-xl);\n  align-items: center;\n}\n\n.chat-image-item:last-child {\n  margin-bottom: var(--space-xl);\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.chat-image-wrapper {\n  position: relative;\n  width: 70%;\n  height: 500px;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-lg);\n  overflow: auto;\n  margin-bottom: 0;\n  flex-shrink: 0;\n}\n\n.image-pan-container {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  position: relative;\n  cursor: grab;\n}\n\n.image-pan-container.grabbing {\n  cursor: grabbing;\n}\n\n.image-pan-content {\n  position: relative;\n  min-width: 100%;\n  min-height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.image-pan-content img {\n  max-width: none;\n  max-height: none;\n  display: block;\n  user-select: none;\n  transition: transform 0.2s ease;\n}\n\n/* 图片缩放控制按钮 */\n.image-zoom-controls {\n  position: absolute;\n  bottom: var(--space-md);\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: var(--space-sm);\n  background: rgba(0, 0, 0, 0.7);\n  border-radius: var(--radius-md);\n  padding: var(--space-sm);\n  z-index: 10;\n}\n\n.zoom-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-sm);\n  border: none;\n  background: rgba(255, 255, 255, 0.9);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  color: var(--text-primary);\n}\n\n.zoom-btn:hover {\n  background: white;\n  transform: scale(1.1);\n}\n\n.zoom-btn svg {\n  width: 20px;\n  height: 20px;\n}\n\n.chat-image-actions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-lg);\n  justify-content: center;\n  padding-bottom: 0;\n  min-width: 140px;\n  align-items: center;\n}\n\n.chat-image-actions .btn:disabled {\n  background: var(--bg-tertiary);\n  color: var(--text-muted);\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* 删除聊天记录按钮 */\n.btn-delete-chat {\n  background: rgba(239, 68, 68, 0.1) !important;\n  color: var(--danger-color) !important;\n}\n\n.btn-delete-chat:hover {\n  background: var(--danger-color) !important;\n  color: white !important;\n}\n\n/* ================================\n   摘要编辑器\n   ================================ */\n.summary-editor-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(8px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1200;\n  padding: var(--space-xl);\n  animation: fadeIn var(--transition-base);\n}\n\n.summary-editor {\n  background: var(--bg-primary);\n  border-radius: var(--radius-xl);\n  width: 100%;\n  max-width: 1000px;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: var(--shadow-xl);\n  animation: slideUp var(--transition-slow);\n  display: flex;\n  flex-direction: column;\n}\n\n.summary-editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--space-lg) var(--space-xl);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.summary-editor-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.summary-editor-content {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n.summary-editor-image {\n  flex: 1;\n  background: var(--bg-tertiary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-xl);\n}\n\n.summary-editor-image img {\n  max-width: 100%;\n  max-height: 500px;\n  object-fit: contain;\n  border-radius: var(--radius-md);\n}\n\n.summary-editor-text {\n  flex: 1;\n  padding: var(--space-xl);\n  border-left: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n}\n\n.summary-editor-textarea {\n  flex: 1;\n  width: 100%;\n  padding: var(--space-lg);\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-md);\n  font-size: 15px;\n  font-family: inherit;\n  line-height: 1.7;\n  resize: none;\n  transition: all var(--transition-fast);\n}\n\n.summary-editor-textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.summary-editor-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--space-md);\n  padding: var(--space-lg) var(--space-xl);\n  border-top: 1px solid var(--border-color);\n}\n\n/* ================================\n   上传遮罩\n   ================================ */\n.uploading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  animation: fadeIn var(--transition-base);\n}\n\n.uploading-content {\n  text-align: center;\n}\n\n.uploading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid var(--border-color);\n  border-top-color: var(--primary-color);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin: 0 auto var(--space-lg);\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* 小 spinner 样式（用于按钮内） */\n.spinner {\n  animation: spin 1s linear infinite;\n}\n\n.uploading-text {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* ================================\n   错误提示\n   ================================ */\n.error-banner {\n  background: linear-gradient(135deg, #fee2e2, #fecaca);\n  border: 1px solid #fca5a5;\n  border-radius: var(--radius-md);\n  padding: var(--space-lg);\n  margin-bottom: var(--space-xl);\n  display: flex;\n  align-items: center;\n  gap: var(--space-md);\n  animation: slideUp var(--transition-base);\n}\n\n.error-banner svg {\n  width: 24px;\n  height: 24px;\n  color: var(--danger-color);\n  flex-shrink: 0;\n}\n\n.error-banner-text {\n  font-size: 14px;\n  color: #991b1b;\n  font-weight: 500;\n}\n\n/* ================================\n   响应式设计\n   ================================ */\n@media (max-width: 1024px) {\n  .housekeepers-grid {\n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: var(--space-lg);\n  }\n\n  .page-header {\n    flex-direction: column;\n    gap: var(--space-lg);\n    text-align: center;\n  }\n\n  .page-title-section {\n    flex-direction: column;\n  }\n\n  .housekeepers-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .stats-section {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .search-section {\n    flex-direction: column;\n  }\n\n  .summary-editor-content {\n    flex-direction: column;\n  }\n\n  .summary-editor-image {\n    max-height: 300px;\n  }\n\n  .card-actions {\n    flex-direction: column;\n  }\n\n  .action-group {\n    border-right: none;\n    padding-right: 0;\n    margin-right: 0;\n    border-bottom: 1px solid var(--border-color);\n    padding-bottom: var(--space-md);\n    margin-bottom: var(--space-md);\n  }\n}\n\n@media (max-width: 480px) {\n  .stats-section {\n    grid-template-columns: 1fr;\n  }\n\n  .stat-card {\n    text-align: center;\n  }\n\n  .stat-icon {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n/* ================================\n   工具类\n   ================================ */\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hidden {\n  display: none !important;\n}\n\n/* ================================\n   认证页面样式（登录/注册）\n   ================================ */\n.auth-page-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 50%, #fef3c7 100%);\n  padding: var(--space-xl);\n}\n\n.auth-card {\n  background: var(--bg-primary);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-xl);\n  border: 1px solid var(--border-color);\n  width: 100%;\n  max-width: 480px;\n  overflow: hidden;\n  animation: slideUp var(--transition-slow);\n}\n\n.auth-header {\n  padding: var(--space-2xl) var(--space-2xl) var(--space-xl);\n  text-align: center;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n}\n\n.auth-icon {\n  width: 64px;\n  height: 64px;\n  margin: 0 auto var(--space-lg);\n  background: linear-gradient(135deg, var(--primary-color), var(--info-color));\n  border-radius: var(--radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--shadow-md);\n}\n\n.auth-icon svg {\n  width: 32px;\n  height: 32px;\n  color: white;\n}\n\n.auth-title {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  letter-spacing: -0.5px;\n}\n\n.auth-subtitle {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin: 8px 0 0 0;\n}\n\n.auth-body {\n  padding: var(--space-2xl);\n}\n\n.auth-footer {\n  padding: var(--space-lg) var(--space-2xl);\n  border-top: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-md);\n}\n\n.auth-footer > span {\n  font-size: 14px;\n  color: var(--text-secondary);\n}\n\n.auth-link {\n  background: none;\n  border: none;\n  color: var(--primary-color);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-xs);\n}\n\n.auth-link:hover {\n  color: var(--primary-hover);\n  text-decoration: underline;\n}\n\n.auth-link.back-home {\n  color: var(--text-secondary);\n}\n\n.auth-link.back-home:hover {\n  color: var(--text-primary);\n}\n\n.auth-link svg {\n  width: 16px;\n  height: 16px;\n}\n\n.auth-btn {\n  width: 100%;\n  padding: 14px;\n  font-size: 16px;\n  margin-top: var(--space-lg);\n}\n\n/* 密码输入框包装器 */\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper .form-input {\n  padding-right: 48px;\n}\n\n.password-toggle {\n  position: absolute;\n  right: var(--space-md);\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-xs);\n  color: var(--text-muted);\n  transition: all var(--transition-fast);\n}\n\n.password-toggle:hover {\n  color: var(--primary-color);\n}\n\n.password-toggle svg {\n  width: 20px;\n  height: 20px;\n}\n\n/* 输入框错误状态 */\n.input-error {\n  border-color: var(--danger-color) !important;\n}\n\n.input-error:focus {\n  border-color: var(--danger-color) !important;\n  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1) !important;\n}\n\n.error-text {\n  display: block;\n  font-size: 12px;\n  color: var(--danger-color);\n  margin-top: var(--space-xs);\n}\n\n/* 表单标签中的图标 */\n.form-label svg {\n  width: 16px;\n  height: 16px;\n  margin-right: var(--space-xs);\n  vertical-align: middle;\n}\n\n.form-label {\n  display: flex;\n  align-items: center;\n}\n\n/* 响应式设计 */\n/* ================================\n   用户头像按钮（头部）\n   ================================ */\n.user-avatar-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid var(--border-color);\n  background: var(--bg-primary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  overflow: hidden;\n  padding: 0;\n}\n\n.user-avatar-btn:hover {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px var(--primary-light);\n}\n\n.user-avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.user-avatar-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n}\n\n.user-avatar-placeholder svg {\n  width: 24px;\n  height: 24px;\n}\n\n/* ================================\n   用户信息编辑页面（移动端设计）\n   ================================ */\n.user-profile-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  z-index: 1300;\n  padding: 0;\n  animation: fadeIn var(--transition-base);\n}\n\n.user-profile-modal {\n  background: var(--bg-primary);\n  border-radius: var(--radius-xl) var(--radius-xl) 0 0;\n  width: 100%;\n  max-width: 520px;\n  max-height: 85vh;\n  overflow: hidden;\n  box-shadow: var(--shadow-xl);\n  animation: slideUp var(--transition-slow);\n  display: flex;\n  flex-direction: column;\n}\n\n.user-profile-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--space-lg) var(--space-xl);\n  border-bottom: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n}\n\n.user-profile-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.user-profile-close {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: var(--bg-tertiary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  color: var(--text-secondary);\n}\n\n.user-profile-close:hover {\n  background: var(--danger-color);\n  color: white;\n}\n\n.user-profile-close svg {\n  width: 20px;\n  height: 20px;\n}\n\n.user-profile-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: var(--space-xl);\n}\n\n.profile-section {\n  margin-bottom: var(--space-xl);\n}\n\n.profile-section-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: var(--space-lg);\n  padding-bottom: var(--space-sm);\n  border-bottom: 2px solid var(--primary-light);\n}\n\n.profile-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: var(--space-sm);\n}\n\n.profile-input,\n.profile-select {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-md);\n  font-size: 15px;\n  font-family: inherit;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: all var(--transition-fast);\n}\n\n.profile-input:focus,\n.profile-select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 4px rgba(8, 145, 178, 0.1);\n}\n\n.profile-input::placeholder {\n  color: var(--text-muted);\n}\n\n/* 头像上传按钮 */\n.avatar-upload-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.avatar-upload-btn {\n  width: 100px;\n  height: 100px;\n  border-radius: var(--radius-lg);\n  border: 3px dashed var(--border-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  overflow: hidden;\n  background: var(--bg-secondary);\n}\n\n.avatar-upload-btn:hover {\n  border-color: var(--primary-color);\n  background: var(--primary-light);\n}\n\n.avatar-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n}\n\n.avatar-placeholder svg {\n  width: 40px;\n  height: 40px;\n}\n\n.avatar-preview {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.uploading-hint {\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n/* 身份证上传按钮 */\n.idcard-upload-container {\n  display: flex;\n  gap: var(--space-lg);\n  justify-content: center;\n}\n\n.idcard-upload-btn {\n  flex: 1;\n  max-width: 140px;\n  padding: var(--space-lg);\n  border-radius: var(--radius-md);\n  border: 2px dashed var(--border-color);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  background: var(--bg-secondary);\n}\n\n.idcard-upload-btn:hover {\n  border-color: var(--primary-color);\n  background: var(--primary-light);\n}\n\n.idcard-icon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--primary-color);\n}\n\n.idcard-icon svg {\n  width: 40px;\n  height: 40px;\n}\n\n.idcard-label {\n  font-size: 12px;\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n.idcard-preview {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: var(--radius-sm);\n}\n\n/* 底部按钮 */\n.user-profile-footer {\n  display: flex;\n  justify-content: center;\n  gap: var(--space-lg);\n  padding: var(--space-lg) var(--space-xl);\n  border-top: 1px solid var(--border-color);\n  background: var(--bg-secondary);\n}\n\n.btn-profile-cancel,\n.btn-profile-save {\n  flex: 1;\n  max-width: 140px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-base);\n}\n\n.btn-profile-cancel {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.btn-profile-cancel:hover {\n  background: var(--border-color);\n}\n\n.btn-profile-save {\n  background: linear-gradient(135deg, var(--primary-color), var(--info-color));\n  color: white;\n}\n\n.btn-profile-save:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-profile-save:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* 修改密码区域 */\n.btn-change-password {\n  margin-top: 16px;\n  width: 100%;\n  padding: 12px 24px;\n  background: linear-gradient(135deg, var(--primary-color), var(--info-color));\n  color: white;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-base);\n}\n\n.btn-change-password:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-change-password:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* 密码输入框在 profile 中的样式 */\n.profile-section .password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.profile-section .password-input-wrapper .profile-input {\n  padding-right: 48px;\n}\n\n.profile-section .password-toggle {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  color: var(--text-muted);\n  transition: all var(--transition-fast);\n}\n\n.profile-section .password-toggle:hover {\n  color: var(--primary-color);\n}\n\n.profile-section .password-toggle svg {\n  width: 20px;\n  height: 20px;\n}\n\n/* 加载状态 */\n.loading-state {\n  padding: var(--space-2xl);\n  text-align: center;\n  color: var(--text-secondary);\n  font-size: 16px;\n}\n\n/* 移动端适配 */\n@media (max-width: 480px) {\n  .auth-card {\n    max-width: 100%;\n  }\n\n  .auth-header,\n  .auth-body,\n  .auth-footer {\n    padding: var(--space-xl);\n  }\n\n  .user-profile-overlay {\n    align-items: flex-end;\n  }\n\n  .user-profile-modal {\n    max-height: 90vh;\n    border-radius: var(--radius-xl) var(--radius-xl) 0 0;\n  }\n\n  .user-profile-body {\n    max-height: calc(90vh - 140px);\n  }\n\n  .idcard-upload-container {\n    flex-direction: row;\n  }\n\n  .idcard-upload-btn {\n    max-width: none;\n    padding: var(--space-md);\n  }\n}\n\n/* ================================\n   照片编辑器\n   ================================ */\n.photo-editor-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1100;\n  padding: var(--space-xl);\n  animation: fadeIn var(--transition-base);\n}\n\n.photo-editor {\n  background: var(--bg-primary);\n  border-radius: var(--radius-xl);\n  width: 100%;\n  max-width: 800px;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: var(--shadow-xl);\n  animation: slideUp var(--transition-slow);\n  display: flex;\n  flex-direction: column;\n}\n\n.photo-editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--space-lg) var(--space-xl);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.photo-editor-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.photo-editor-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: var(--space-xl);\n}\n\n.photo-editor-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: var(--space-lg);\n}\n\n.photo-editor-item {\n  position: relative;\n}\n\n.photo-editor-image-wrapper {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  border: 2px solid var(--border-color);\n}\n\n.photo-editor-image-wrapper img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.photo-editor-delete-btn {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(239, 68, 68, 0.9);\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: all var(--transition-fast);\n  z-index: 10;\n}\n\n.photo-editor-image-wrapper:hover .photo-editor-delete-btn {\n  opacity: 1;\n}\n\n.photo-editor-delete-btn:hover {\n  background: var(--danger-color);\n  transform: translate(-50%, -50%) scale(1.1);\n}\n\n.photo-editor-delete-btn svg {\n  width: 24px;\n  height: 24px;\n}\n\n.photo-editor-replace-btn {\n  width: 100%;\n  padding: 8px;\n  margin-top: var(--space-sm);\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.photo-editor-replace-btn:hover {\n  background: var(--border-color);\n}\n\n.photo-editor-upload-slot {\n  aspect-ratio: 1;\n  border-radius: var(--radius-md);\n  border: 2px dashed var(--border-color);\n  background: var(--bg-secondary);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.photo-editor-upload-slot:hover {\n  border-color: var(--primary-color);\n  background: var(--primary-light);\n}\n\n.photo-editor-upload-slot svg {\n  width: 32px;\n  height: 32px;\n  color: var(--primary-color);\n}\n\n.photo-editor-upload-slot span {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.photo-editor-add-slot {\n  aspect-ratio: 1;\n  border-radius: var(--radius-md);\n  border: 2px dashed var(--primary-color);\n  background: var(--primary-light);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.photo-editor-add-slot:hover {\n  background: rgba(8, 145, 178, 0.15);\n}\n\n.photo-editor-add-slot svg {\n  width: 32px;\n  height: 32px;\n  color: var(--primary-color);\n}\n\n.photo-editor-add-slot span {\n  font-size: 13px;\n  color: var(--primary-color);\n  font-weight: 500;\n}\n\n.photo-editor-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--space-md);\n  padding: var(--space-lg) var(--space-xl);\n  border-top: 1px solid var(--border-color);\n}\n\n/* ================================\n   内联照片编辑样式\n   ================================ */\n.photo-inline-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--space-md);\n  padding: var(--space-md) 0;\n  margin-top: var(--space-sm);\n  border-top: 1px solid var(--border-color);\n}\n\n.photo-grid-add {\n  border: 2px dashed var(--primary-color);\n  background: var(--primary-light);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-sm);\n}\n\n.photo-grid-add:hover {\n  background: rgba(8, 145, 178, 0.15);\n}\n\n.photo-grid-add svg {\n  width: 32px;\n  height: 32px;\n  color: var(--primary-color);\n}\n\n.photo-grid-add span {\n  font-size: 13px;\n  color: var(--primary-color);\n  font-weight: 500;\n}\n\n.photo-delete-inline {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(239, 68, 68, 0.95);\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 1;\n  transition: all var(--transition-fast);\n  z-index: 10;\n  box-shadow: var(--shadow-md);\n}\n\n.photo-delete-inline:hover {\n  background: var(--danger-color);\n  transform: scale(1.1);\n}\n\n.photo-delete-inline svg {\n  width: 18px;\n  height: 18px;\n}\n\n.photo-upload-inline {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(8, 145, 178, 0.9);\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  z-index: 10;\n  box-shadow: var(--shadow-md);\n}\n\n.photo-upload-inline:hover {\n  background: var(--primary-hover);\n  transform: translate(-50%, -50%) scale(1.1);\n}\n\n.photo-upload-inline svg {\n  width: 24px;\n  height: 24px;\n}\n\n/* 编辑状态下的图片容器 - 需要position:relative以支持浮层按钮 */\n.photo-grid-editing {\n  position: relative;\n}\n\n/* 中间位置的删除按钮 */\n.photo-delete-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(239, 68, 68, 0.9);\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  z-index: 10;\n  box-shadow: var(--shadow-md);\n}\n\n.photo-delete-center:hover {\n  background: var(--danger-color);\n  transform: translate(-50%, -50%) scale(1.1);\n}\n\n.photo-delete-center svg {\n  width: 24px;\n  height: 24px;\n}\n\n/* 空白添加区域样式 - 带虚线边框 */\n.photo-grid-add-center {\n  border: 2px dashed var(--primary-color);\n  background: rgba(8, 145, 178, 0.08);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  position: relative;\n}\n\n.photo-grid-add-center:hover {\n  background: rgba(8, 145, 178, 0.15);\n}\n\n/* 中间位置的添加按钮 */\n.photo-add-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(8, 145, 178, 0.9);\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  z-index: 10;\n  box-shadow: var(--shadow-md);\n}\n\n.photo-add-center:hover {\n  background: var(--primary-hover);\n  transform: translate(-50%, -50%) scale(1.1);\n}\n\n.photo-add-center svg {\n  width: 24px;\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
